import Skeleton from "react-loading-skeleton";
import styles from "./index.module.scss";

const CampusSkeleton = () => {
    return (
        <div className="row px-3 px-md-0">
            {Array.from(Array(3).keys()).map((_, i) => {
                return (
                    <div className={styles.col} key={i}>
                        <div className={styles.skeletonBottom}>
                            <Skeleton className={styles.skeleton1} height={10} width={150} />
                        </div>
                        <div className={styles.skeletonTop}>
                            <Skeleton className={styles.skeleton2} height={30} width={150} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default CampusSkeleton;